<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #F0F0F0;">


    <div class="row" >
      <div class="category-head" style="background-color: #ffffff">
        <div class="back-link" style="margin-top: 6px;">
          <a @click="$router.back()"> <i class="fas fa-chevron-left " style="color: #414141"></i></a>
        </div>
        <div class="category-title">
          <p class="pt-3" style="font-weight: bold;color: #414141;text-align: center;"> {{ $t('SETTINGS') }} </p>
        </div>
        <router-link class="search-friend-icon" to="/find-friends">

        </router-link>
      </div>
    </div>
        <div class="row mt-3">
          <div class="settings-content">
            <div class="content d-flex justify-content-between">
              <div class="title">{{ $t('DAILY_UPDATE') }}</div>
              <div class="settings-option">
                <div class="toggle active-toggle">
                  <input type="radio" @click="updateSettings('daily_updates', false)" :checked="!dailyUpdate">
                  <input type="radio" @click="updateSettings('daily_updates', true)" :checked="dailyUpdate">
                  <div class="toggle__pointer"></div>
                </div>
              </div>
            </div>
            <div class="content d-flex justify-content-between">
              <div class="title">{{ $t('NEW_TOPIC')}}</div>
              <div class="settings-option">
                <div class="toggle">
                  <input type="radio" @click="updateSettings('new_topics', false)" :checked="!newTopic">
                  <input type="radio" @click="updateSettings('new_topics', true)" :checked="newTopic">
                  <div class="toggle__pointer"></div>
                </div>
              </div>
            </div>
            <div class="content d-flex justify-content-between">
              <div class="title">{{ $t ('NEW_TOURNAMENT')}}</div>
              <div class="settings-option">
                <div class="toggle">
                  <input type="radio" name="radio" @click="updateSettings('new_tournament', false)"
                         :checked="!newTournament">
                  <input type="radio" name="radio" @click="updateSettings('new_tournament', true)"
                         :checked="newTournament">
                  <div class="toggle__pointer"></div>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="upper-content d-flex justify-content-between">
                <div class="title">{{ $t ('SOUND_EFFECT')}}</div>
                <div class="settings-option">
                  <div class="cursor-pointer" @click="soundEffectChange(false)" v-if="soundEffect">
                    <img src="@/assets/img/volume.png" height="20" alt="">
                  </div>
                  <div class="cursor-pointer" @click="soundEffectChange(true)" v-if="! soundEffect">
                    <img src="@/assets/img/mute.png" height="20" alt="">
                  </div>
                </div>
              </div>
              <div class="system-sound">
                <Slider v-model="sound" :lazy="false" @update="updateSound" class="slider-blue"/>
              </div>
            </div>
            <div class="content">
              <div class="upper-content d-flex justify-content-between">
                <div class="title">{{ $t ('MUSIC')}}</div>
                <div class="settings-option">
                  <div class="cursor-pointer" @click="musicEffectChange(false)" v-if="musicEffect">
                    <img src="@/assets/img/volume.png" height="20" alt="">
                  </div>
                  <div class="cursor-pointer" @click="musicEffectChange(true)" v-if="! musicEffect">
                    <img src="@/assets/img/mute.png" height="20" alt="">
                  </div>
                </div>
              </div>
              <div class="system-sound">
                <Slider v-model="music" :lazy="false" @update="updateMusic" class="slider-blue"/>
              </div>
            </div>
            <div class="content d-flex justify-content-between">
              <div class="title">{{ $t ('LOGOUT')}}</div>
              <div class="settings-option cursor-pointer" @click="logout">
                <img src="@/assets/img/happy_img/logout.png" alt="logout" height="32">
              </div>
            </div>

            <div class="content d-flex justify-content-between">
              <div class="title">Switch Language</div>
              <div class="settings-option">
                <select class="form-control"  v-model="selectedLanguage" @change="setLanguage" style="color: #3EAAFF;font-weight: 700;">
                  <option :value="language.code" :selected="language.code === selectedLanguage" v-for="language in languages" :key="language.code">{{ language.title }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>


</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import Slider from "@vueform/slider";
import "@vueform/slider/themes/default.css";
import {availableLanguages} from "@/i18nPlugin";

export default {
  name: "Settings",
  components: {
    Loader,
    Slider,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      userSettings: [],
      dailyUpdate: false,
      newTopic: true,
      newTournament: true,
      soundEffect: true,
      musicEffect: true,
      music: localStorage.getItem('music') || 0,
      sound: localStorage.getItem('sound') || 0,
      languages: availableLanguages,
      selectedLanguage: this.$store.state.lang,
    }
  },
  created() {
    this.getUserSettings();
    this.soundEffect = this.sound > 0;
    this.musicEffect = this.music > 0;
  },
  methods: {
    setUserSettings() {
      this.dailyUpdate = this.userSettings.daily_updates;
      this.newTopic = this.userSettings.new_topics;
      this.newTournament = this.userSettings.new_tournament;
    },
    setLanguage() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/switch-user-language', {language: this.selectedLanguage}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.$store.dispatch('saveLang', this.selectedLanguage);
              this.$i18n.locale = this.selectedLanguage;
              this.$router.push({path: 'dashboard'})
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getUserSettings() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/settings', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.userSettings = {
                'daily_updates': response.data.daily_updates,
                'new_topics': response.data.new_topics,
                'new_tournament': response.data.new_tournament,
              };
              this.setUserSettings();
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    updateSettings(type, data) {
      if (type === 'daily_updates') {
        this.dailyUpdate = data;
      }
      if (type === 'new_topics') {
        this.newTopic = data;
      }
      if (type === 'new_tournament') {
        this.newTournament = data;
      }

      this.loaderActive = false;
      let setting_data = {
        'daily_updates': this.dailyUpdate,
        'new_topics': this.newTopic,
        'new_tournament': this.newTournament,
      }
      sendRequest('post', 'v2.0/settings', setting_data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.userSettings = setting_data;
              this.setUserSettings();
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

    soundEffectChange(sound) {
      this.soundEffect = sound;
      this.sound = this.soundEffect ? 100 : 0;
      this.$store.dispatch('updateSoundOrMusic', {
        'type': 'sound',
        'data': this.sound,
      });
    },
    musicEffectChange(music) {
      this.musicEffect = music;
      this.music = this.musicEffect ? 100 : 0;
      this.$store.dispatch('updateSoundOrMusic', {
        'type': 'music',
        'data': this.music,
      });
    },
    updateMusic() {
      this.musicEffect = this.music > 0;
      this.$store.dispatch('updateSoundOrMusic', {
        'type': 'music',
        'data': this.music,
      });
    },
    updateSound() {
      this.soundEffect = this.sound > 0;
      this.$store.dispatch('updateSoundOrMusic', {
        'type': 'sound',
        'data': this.sound,
      });
    },
    logout() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/logout', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.$store.dispatch('removeAuthUser');
              this.$router.push('/login')
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    }
  }
}
</script>

<style scoped>
.slider-blue {
  --slider-connect-bg: #00AAFF;
  --slider-tooltip-bg: #00AAFF;
  --slider-handle-ring-color: #00AAFF;
}
</style>
